// PLAN-permalink-cockpit-convergence follow-up: Cockpit 内で item を開くリンクは
// すべて実 <a href> にする。Ctrl/Cmd+Click で新タブ、コンテキストメニューの
// 「新しいタブで開く」、戻るボタンが効くようにするため。
//
// 使い方:
//   <a href={permalinkHref(id)} onClick={(e) => itemLinkClick(e, () => setSelectedItem({ id, itemType }))}>
//
// 通常クリックは preventDefault してアプリ内遷移 (onPlainClick)。
// modifier 付き (Ctrl/Cmd/Shift/Alt) はブラウザに任せる。
import type { MouseEvent } from 'react'

export function permalinkHref(id: string): string {
  return `/v/${id}`
}

export function itemLinkClick(e: MouseEvent, onPlainClick: () => void): void {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
  e.preventDefault()
  onPlainClick()
}
